import { BaseModel } from "@/models/base.model"
import { type IProjectPurchaseItem } from "@/interfaces/api/project-purchase-item.interface"

export class ProjectPurchaseItem extends BaseModel implements IProjectPurchaseItem {
  public static className = "ProjectPurchaseItem" // Used for socket communication.
  public static verboseName = "projectinkoopafspraak"

  project: string
  purchaseItem: string

  unitPrice: string

  constructor(projectPurchaseItem: IProjectPurchaseItem) {
    super(projectPurchaseItem)
    this.project = projectPurchaseItem.project
    this.purchaseItem = projectPurchaseItem.purchaseItem
    this.unitPrice = projectPurchaseItem.unitPrice
  }
}
